import React from "react";
import {observer} from "mobx-react-lite";
import {authStore} from "../../store/authStore";

const InviteShowPopup = observer(() => (
    <div className="invite-popup">{authStore.inviteMessage}</div>
));

export default InviteShowPopup;